import { useState } from 'react';
import { flashFeed, hotWords, updateTimeline } from '@/mocks/feed';
import SectionHeading from './SectionHeading';

export default function FlashFeed() {
  const [expanded, setExpanded] = useState(false);
  const list = expanded ? flashFeed : flashFeed.slice(0, 4);

  return (
    <section id="kuaixun" className="bg-background-50 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          index="01"
          title="今日快讯流"
          subtitle="按时间为序梳理投稿线索，标注核实进度与讨论热度"
          accent="primary"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8">
            <div className="relative">
              <span className="absolute left-[5px] top-2 bottom-2 w-px bg-background-200" aria-hidden="true"></span>
              <div className="space-y-4">
                {list.map((item) => (
                  <article key={item.id} className="relative pl-7">
                    <span className="absolute left-0 top-4 w-3 h-3 rounded-full border-2 border-background-50 bg-primary-500"></span>
                    <div className="rounded-lg border border-background-200 bg-background-50 hover:border-primary-200 transition-colors">
                      <div className="flex gap-4 p-4">
                        <div className="flex-1 min-w-0">
                          <div className="flex flex-wrap items-center gap-2 text-xs">
                            <span className="font-label font-bold text-foreground-900">{item.time}</span>
                            <span className="px-1.5 py-0.5 rounded bg-primary-100 text-primary-700">{item.category}</span>
                            <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">{item.status}</span>
                          </div>
                          <h3 className="mt-2 font-heading font-bold text-base text-foreground-950 leading-snug">{item.title}</h3>
                          <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                          <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                            <span><i className="ri-user-voice-line"></i> {item.source}</span>
                            <span><i className="ri-chat-3-line"></i> {item.comments}</span>
                            <span><i className="ri-thumb-up-line"></i> {item.likes}</span>
                            <span className="text-primary-600"><i className="ri-fire-line"></i> {item.heat}</span>
                          </div>
                        </div>
                        <div className="hidden sm:block w-[136px] h-[96px] rounded-md overflow-hidden shrink-0 border border-background-200">
                          <img
                            src={item.cover}
                            alt={item.title}
                            title={`${item.title} 黑料投稿${item.category}`}
                            className="w-full h-full object-cover object-top"
                          />
                        </div>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>

            <button
              type="button"
              onClick={() => setExpanded((v) => !v)}
              className="mt-5 w-full h-11 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className={expanded ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}></i>
              {expanded ? '收起快讯' : '展开更多快讯'}
            </button>
          </div>

          <aside className="lg:col-span-4 space-y-5">
            <div className="rounded-lg border border-background-200 bg-background-50">
              <div className="flex items-center justify-between px-4 py-3 border-b border-background-200">
                <h3 className="font-heading font-bold text-sm text-foreground-950 flex items-center gap-2">
                  <span className="w-1 h-4 rounded-full bg-accent-500"></span>
                  今日热词
                </h3>
                <i className="ri-fire-line text-primary-500"></i>
              </div>
              <ul className="p-2">
                {hotWords.map((entry, index) => (
                  <li key={entry.word} className="flex items-center gap-3 px-2 py-2 rounded-md hover:bg-background-100 transition-colors">
                    <span
                      className={`w-5 h-5 rounded flex items-center justify-center text-[11px] font-bold ${index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'}`}
                    >
                      {index + 1}
                    </span>
                    <span className="text-sm text-foreground-800">{entry.word}</span>
                    <span className="ml-auto text-xs text-foreground-500">{entry.count}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50">
              <div className="px-4 py-3 border-b border-background-200">
                <h3 className="font-heading font-bold text-sm text-foreground-950 flex items-center gap-2">
                  <span className="w-1 h-4 rounded-full bg-primary-500"></span>
                  更新记录
                </h3>
              </div>
              <ul className="p-4 space-y-3">
                {updateTimeline.map((entry) => (
                  <li key={entry.time} className="flex gap-3">
                    <span className="text-xs font-label text-foreground-500 w-10 shrink-0 pt-0.5">{entry.time}</span>
                    <span className="relative pl-4 text-xs text-foreground-700 leading-relaxed">
                      <span className="absolute left-0 top-1.5 w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                      {entry.text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-primary-200 bg-primary-50 p-4">
              <h3 className="font-heading font-bold text-sm text-foreground-950 flex items-center gap-2">
                <i className="ri-lightbulb-line text-primary-600"></i>
                投稿小提示
              </h3>
              <p className="mt-2 text-xs text-foreground-700 leading-relaxed">
                提供线索时请尽量写清时间、地点与来源。若涉及隐私信息，请先做打码处理，方便编辑快速核实。
              </p>
              <a
                href="#tougao"
                className="mt-3 inline-flex items-center gap-1.5 text-xs text-primary-700 hover:text-primary-800 whitespace-nowrap cursor-pointer"
              >
                前往投稿通道
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}